<feedback-display-header [title]="'feedback-session-feedback-display_analytics-header' | translate">
  <div header-filters>
    @if ((analytics$ | async); as loadedAnalytics) {
      @if (loadedAnalytics.length > 1) {
        <mat-form-field goSelect>
          <mat-select
            [(ngModel)]="currentAnalytic"
            (selectionChange)="selectAnalytic($event)"
            disableOptionCentering
            panelClass="offsetPanel">
            <mat-select-trigger>
              @if ((selectedAnalytic$ | async); as selectedAnalytic) {
                <span class="selected-analytic">
                  @if (selectedAnalytic.speaker_label.length === 1) {
                    {{ 'transcript-viewer_speaker' | translate : { speaker: selectedAnalytic.speaker_label } }}
                  }
                  @if (selectedAnalytic.speaker_label.length > 1) {
                    {{ selectedAnalytic.speaker_label }}
                  }
                </span>
              }
            </mat-select-trigger>
            @for (analytic of loadedAnalytics; track analytic) {
              <mat-option [value]="analytic">
                @if (analytic.speaker_label.length === 1) {
                  {{ 'transcript-viewer_speaker' | translate : { speaker: analytic.speaker_label } }}
                }
                @if (analytic.speaker_label.length > 1) {
                  {{ analytic.speaker_label }}
                }
              </mat-option>
            }
          </mat-select>
          <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
        </mat-form-field>
      }
    }
    @if (showBetaLabel && (isLoading$ | async) === false) {
      <span class="beta-label" translate="common_beta"></span>
    }
  </div>
</feedback-display-header>

@if (isLoading$ | async) {
  <div class="loading-view">
    <i class="ficon-spinner ficon-spin"></i>
    <span translate="common_loading"></span>
  </div>
} @else {
  @if (requestErrorOccurred$ | async) {
    <ngx-zero-state>
      <div zero-state-title translate="transcript-viewer-zero-state_loading-failed"></div>
      <div zero-state-subtext translate="session-analytics-zero-state_loading-failed-subtext"></div>
      <div zero-state-graphic-bottom>
      <img class="zero-state-image" [src]="activeBrandService.getImage('floating-astronaut.svg')" alt="{{'transcript-viewer-zero-state_loading-failed-image-alt' | translate}}">
      </div>
    </ngx-zero-state>
  }
}

<!-- Error Fetching Transcript -->

@if (parsedMediaTranscript$ | async; as transcript) {
  <section class="transcript-container">
    <feedback-graph
      (onExpanded)="onExpanded(analyticItems.FEEDBACK)"
      [isExpanded]="isExpanded(analyticItems.FEEDBACK) | async"
      [duration]="media.duration"
      [playerSync]="playerSync"
      [tagsList]="tagsList">
    </feedback-graph>
    @if (showDivider(transcript)) {
      <div class="advanced-divider">
        <badge
          [badgeColor]="BadgeColors.SUCCESS"
          [badgeLabel]="'common_advanced-plan' | translate">
        </badge>
        <span class="divider-line"></span>
      </div>
    }
    @if (maySeeTranscriptionAnalytics() && transcript.status === TranscriptStatus.COMPLETED) {
      <word-metric-graph
        *teaseWall="analyticsTeaseWallConfig; hide: (isExpanded(analyticItems.FILLER) | async) === false"
        (onExpanded)="onExpanded(analyticItems.FILLER)"
        [isExpanded]="isExpanded(analyticItems.FILLER) | async"
        [type]="WordGraphType.FILLER"
        [analytic]="selectedAnalytic$ | async"
        [media]="media"
        [playerSync]="playerSync"
        [shouldTease]="shouldTease">
      </word-metric-graph>
      @if ($any({value: selectedAnalytic$ | async}); as selectedAnalytic) {
        <pause-metric-graph *teaseWall="analyticsTeaseWallConfig; hide: (isExpanded(analyticItems.PAUSE) | async) === false"
          (onExpanded)="onExpanded(analyticItems.PAUSE)"
          [isExpanded]="isExpanded(analyticItems.PAUSE) | async"
          [media]="media"
          [playerSync]="playerSync"
          [pauseInstances]="selectedAnalytic.value?.pause_instances || []"
          [totalPauses]="selectedAnalytic.value?.pause_total || 0"
          [totalLengthyPauses]="selectedAnalytic.value?.pause_lengthy_total || 0"
          [shouldTease]="shouldTease">
        </pause-metric-graph>
      }
      <pace-metric-graph
        *teaseWall="analyticsTeaseWallConfig; hide: (isExpanded(analyticItems.PACE) | async) === false"
        (onExpanded)="onExpanded(analyticItems.PACE)"
        [isExpanded]="isExpanded(analyticItems.PACE) | async"
        [media]="media"
        [playerSync]="playerSync"
        [utterances]="selectedUtterances$ | async"
        [shouldTease]="shouldTease">
      </pace-metric-graph>
      <word-metric-graph
        *teaseWall="analyticsTeaseWallConfig; hide: (isExpanded(analyticItems.HEDGING) | async) === false"
        (onExpanded)="onExpanded(analyticItems.HEDGING)"
        [isExpanded]="isExpanded(analyticItems.HEDGING) | async"
        [type]="WordGraphType.HEDGING"
        [analytic]="selectedAnalytic$ | async"
        [media]="media"
        [playerSync]="playerSync"
        [shouldTease]="shouldTease">
      </word-metric-graph>
    }
  </section>
}

